import Base from './base';

export default class FulfillmentRequest extends Base {
  resource = '/fulfillment_requests';
}
